import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import {
  Grid,
} from 'react-virtualized'
import scrollbarSize from 'dom-helpers/util/scrollbarSize'

import styles from './styles.scss'

class HeaderGrid extends Component {
  static propTypes = {
    getCache: PropTypes.func.isRequired,
    cellRenderer: PropTypes.func.isRequired,
    list: PropTypes.array.isRequired,
    width: PropTypes.number.isRequired,
    scrollLeft: PropTypes.number.isRequired,
    gridParams: PropTypes.object.isRequired,
    leftGridParams: PropTypes.object.isRequired,
    headerGridParams: PropTypes.object.isRequired,
  }

  componentDidMount() {
    if (this.props.register)
      this.props.register(this.grid)
  }

  componentWillUnmount() {
    if (this.props.unregister)
      this.props.unregister(this.grid)
  }

  setRef = (ref)  => this.grid = ref
  getContentWidth = () => this.props.width - scrollbarSize()
  getColumnCount = () => this.props.list[0] ? this.props.list[0].length : 0

  render() {
    const {
      list,
      getCache,
      scrollLeft,
      width,
      gridParams,
      leftGridParams,
      headerGridParams,
      cellRenderer,
    } = this.props
    const {
      overscanColumnCount,
      estimatedColumnSize,
    } = gridParams
    const {
      columnWidth,
    } = leftGridParams
    const {
      rowCount,
      rowHeight,
    } = headerGridParams
    const cache = getCache()

    return (
      <div
        style={{
          height: rowHeight,
          width,
        }}>
        <Grid
          ref={this.setRef}
          deferredMeasurementCache={cache}
          columnWidth={cache.columnWidth}
          columnCount={this.getColumnCount()}
          height={rowHeight}
          overscanColumnCount={overscanColumnCount}
          cellRenderer={cellRenderer}
          rowHeight={rowHeight}
          rowCount={rowCount}
          scrollLeft={scrollLeft}
          estimatedColumnSize={estimatedColumnSize}
          styleName='headerGrid'
          width={this.getContentWidth()}
        />
      </div>
    )
  }
}

export default CSSModules(styles, HeaderGrid)
